<div class="form-group">
  <label for="defaultBankAccount">{{'SERVICE-OTP.DEFAULT_BANK_ACCOUNT' | translate}}</label>
  <select [(ngModel)]="service.defaultBankAccount" id="defaultBankAccount" class="form-control" name="defaultBankAccount" #defaultBankAccount="ngModel">
    @for (value of banckAccounts; track value) {
      <option value={{value.accountName}}>
        {{value.accountName}}
      </option>
    }
  </select>
</div>

<div class="form-group">
  <label for="defaultCurrency">{{'SERVICE-OTP.DEFAULT_CURRENCY' | translate}}</label>
  <select [(ngModel)]="service.defaultCurrency" id="defaultCurrency" class="form-control" name="defaultCurrency" #defaultCurrency="ngModel">
    @for (value of currencies; track value) {
      <option value={{value.code}}>
        {{value.code}}
      </option>
    }
  </select>
</div>